import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const activateSite = (pin: string): AxiosPromise =>
  instance.put(`/api/sites/${pin}/activate`);

export default activateSite;
